export default __webpack_public_path__ + "static/media/190629_190332_IMG_9306.f5676dd5.jpg";